import React, { cloneElement, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useHistory,
} from "react-router-dom";
import Hoc from "./hoc/hoc";
import Danhsachyeucau from "./containers/Danhsachyeucau";
// import BlankLayout from "./containers/BlankLayout";
import TicketDetail from "./containers/TicketDetail";
import TicketCreate from "./containers/TicketCreate";
import Danhsachchopheduyet from "./containers/Danhsachchopheduyet";
import Danhsachdapheduyet from "./containers/Danhsachdapheduyet";
import Danhsachnhiemvucanhan from "./containers/Danhsachnhiemvucanhan";
import Danhsachnhiemvuall from "./containers/Danhsachnhiemvuall";
import ListticketAll_SupAD from "./containers/ListticketAll_SupAD";
import TicketReport from "./containers/TicketReport";
import TicketExport_data from "./containers/TicketExport_data";
import Settings from "./containers/Settings";
import SettingsUsers from "./containers/SettingsUsers";
import SettingsBophanxulys from "./containers/SettingsBophanxulys";
import SettingsBophansudung from "./containers/SettingsBophansudung";
import UserCreate from "./containers/UserCreate";
import SettingsLoaiyeucau from "./containers/SettingsLoaiyeucau";
import NotFoundLayout from "./containers/notfound";
import NotPermission from "./containers/notPermission";
import TicketFromMail from "./containers/TicketFromMail";
import TicketChangeStatus from "./containers/TicketChangeStatus";
import CandidateManagement from "./containers/pages/candidateManagement/index";
import RecruitmentRequirements from "./containers/pages/recruitmentRequirements/index";
import ReportRecruitment from "./containers/pages/reportRecruitment/index";
// import InterviewSchedule from "./containers/pages/interviewSchedule/index";
import InterviewScheduleTable from "./containers/pages/interviewScheduleTable/index";
import DetailInterviewSchedule from "./containers/pages/detailInterviewSchedule/index";
import SettingsTeam from "./containers/SettingsTeam";
import SettingsChucVu from "./containers/SettingsChucVu";
import SettingsVanPhong from "./containers/SettingsVanPhong";

const ProtectAccountRoute = (props) => {
  const { data, auth, children, path } = props;
  // data lấy từ getRole ở page Layout, chứa toàn bộ phân quyền ở bảng 04 06
  return (
    <Route
      path={path}
      render={() => {
        if (data !== null) {
          return data !== null &&
            auth !== null &&
            data.includes(auth) === true ? (
            children
          ) : (
            <Redirect to={"/notpermission"} />
          );
        }
      }}
    />
  );
};

const BaseRouter = ({ data }) => (
  <Hoc>
    <Switch>
      <ProtectAccountRoute
        exact
        path="/danhsachyeucau"
        data={data}
        auth={"can_create"}
      >
        <Danhsachyeucau />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/chopheduyet"
        data={data}
        auth={"can_accept"}
      >
        <Danhsachchopheduyet />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/dapheduyet"
        data={data}
        auth={"can_accept"}
      >
        <Danhsachdapheduyet />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/danhsachxulycanhan"
        data={data}
        auth={"can_process"}
      >
        <Danhsachnhiemvucanhan />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/danhsachxuly"
        data={data}
        auth={"can_process"}
      >
        <Danhsachnhiemvuall />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/create_ticket"
        data={data}
        auth={"can_create"}
      >
        <TicketCreate />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/tickets/:ticketID"
        data={data}
        auth={"can_create"}
      >
        <TicketDetail />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/tickets-from-mail/view/:ticketID"
        data={data}
        auth={"can_create"}
      >
        <TicketFromMail />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/reports"
        data={data}
        auth={"can_report"}
      >
        <TicketReport />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/export_data"
        data={data}
        auth={"can_report"} // 190424 đổi can_export thành can_report
      >
        <TicketExport_data />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/settings"
        data={data}
        auth={"can_system"}
      >
        <Settings />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/settings/users"
        data={data}
        auth={"can_system"}
      >
        <SettingsUsers />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/settings/bophanxuly"
        data={data}
        auth={"can_system"}
      >
        <SettingsBophanxulys />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/settings/bophansudung"
        data={data}
        auth={"can_system"}
      >
        <SettingsBophansudung />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/settings/loaiyeucau"
        data={data}
        auth={"can_system"}
      >
        <SettingsLoaiyeucau />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/settings/create_user"
        data={data}
        auth={"can_system"}
      >
        <UserCreate />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/tatcayeucau"
        data={data}
        auth={"can_allticket"}
      >
        <ListticketAll_SupAD />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/change_status"
        data={data}
        auth={"can_system"}
      >
        <TicketChangeStatus />
      </ProtectAccountRoute>

      <ProtectAccountRoute
        exact
        path="/recruitment_system"
        data={data}
        auth={"can_hr_rec"}
      >
        <RecruitmentRequirements />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/candidate_management"
        data={data}
        auth={"can_hr_rec"}
      >
        <CandidateManagement />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/interview-schedule-table"
        data={data}
        auth={"can_hr_rec"}
      >
        <InterviewScheduleTable />
      </ProtectAccountRoute>
      {/* <ProtectAccountRoute
        exact
        path="/interview-schedule"
        data={data}
        auth={"can_hr_rec"}
      >
        <InterviewSchedule />
      </ProtectAccountRoute> */}
      <ProtectAccountRoute
        exact
        path="/detail-interview/:codeInterview"
        data={data}
        auth={"can_cv_interview"}
      >
        <DetailInterviewSchedule />
      </ProtectAccountRoute>
      <ProtectAccountRoute
        exact
        path="/report_recruitment"
        data={data}
        auth={"can_hr_rec"}
      >
        <ReportRecruitment />
      </ProtectAccountRoute>

      <ProtectAccountRoute exact path="/" data={data} auth={"can_create"}>
        <Danhsachyeucau />
      </ProtectAccountRoute>

      <ProtectAccountRoute
        exact
        path="/settings/team"
        data={data}
        auth={"can_system"}
      >
        <SettingsTeam />
      </ProtectAccountRoute>

      <ProtectAccountRoute
        exact
        path="/settings/chucvu"
        data={data}
        auth={"can_system"}
      >
        <SettingsChucVu />
      </ProtectAccountRoute>

      <ProtectAccountRoute
        exact
        path="/settings/vanphong"
        data={data}
        auth={"can_system"}
      >
        <SettingsVanPhong />
      </ProtectAccountRoute>

      <Route exact path="/notpermission" component={NotPermission} />
      <Route path="/" component={NotFoundLayout} />
    </Switch>
  </Hoc>
);

export default BaseRouter;
